import {BasePopupProps} from "../../Models";
import FlintTextArea from "@components/controls/FlintTextArea";
import {useState} from "react";
import {WindowActionsBar} from "@progress/kendo-react-dialogs";
import FlintButton from "@components/controls/FlintButton";
import {useTranslation} from "react-i18next";
import {Error} from "@progress/kendo-react-labels";

export default function TextAreaInputDialog(props: TextAreaInputDialogProps) {
    const {state, handlers, validators} = useTextAreaInputDialog(props);
    const {t} = useTranslation();
    return <div className={"text-area-popup"}>
        {props.description &&
            <div className={"my-2"} dangerouslySetInnerHTML={{__html: props.description}}/>}
        <div className={"form-group mb-4"}>
            <FlintTextArea
                required={true}
                valid={!validators.validationMessage}
                rows={5}
                value={state.message.get}
                onChange={x => handlers.handleMessageChanged(x.value)}
            />
            {validators.validationMessage &&
                <Error>{validators.validationMessage}</Error>}
        </div>
        <WindowActionsBar layout={"stretched"}>
            <FlintButton themeColor={"secondary"}
                         onClick={handlers.handleCancelled}>{t("Cancel")}</FlintButton>
            <FlintButton themeColor={"primary"}
                         onClick={handlers.handleConfirmed}>{t("Confirm")}</FlintButton>
        </WindowActionsBar>
    </div>
}

export interface TextAreaInputDialogProps extends BasePopupProps<string> {
    description?: string;
}


function useTextAreaInputDialog(props: TextAreaInputDialogProps) {
    const [message, setMessage] = useState<string>("");
    const [validationMessage, setValidationMessage] = useState<string>("");

    function handleCancelled() {
        props.OnCancelled();
    }

    function handleConfirmed() {
        if (!message) {
            setValidationMessage("Field is required");
            return;
        }
        props.OnConfirmedAndSaved(message);
    }
    function handleMessageChanged(message:string){
        if (!message) {
            setValidationMessage("Field is required");
        }
        else setValidationMessage("");
        setMessage(message);
    }
    return {
        state: {
            message: {get: message, set: setMessage},
        },
        handlers: {
            handleConfirmed,
            handleCancelled,
            handleMessageChanged,
        },
        validators: {
            validationMessage
        }
    }
}